import { render } from "./TableTab.vue?vue&type=template&id=aec452b8&ts=true"
import script from "./TableTab.vue?vue&type=script&lang=ts"
export * from "./TableTab.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__